class BrandStoryAnimation {
  constructor() {
    this.images = [];
    this.isRunning = false;
    this.animationId = null;
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {

    const imageElements = document.querySelectorAll('.brand-story__image');
    const templateHandle = document.body?.dataset?.template || '';
    const isPageTemplate = templateHandle.includes('page.brand-story');

    const isMobile = window.innerWidth <= 1200;

    if (isMobile) {
      return;
    }

    if (isPageTemplate) {
      imageElements.forEach((img) => {
        img.style.transform = '';
        img.style.removeProperty('transform');
      });
      return;
    }

    setTimeout(() => {
      imageElements.forEach((img, index) => {

        this.images.push({
          element: img,
          baseRotation: this.getRotationFromCSS(img),
          floatX: 0,
          floatY: 0,
          time: Math.random() * Math.PI * 2,
          speed: 0.015 + Math.random() * 0.01
        });
      });

      this.startAnimation();
    }, 100);
  }

  getRotationFromCSS(element) {
    const computedStyle = window.getComputedStyle(element);
    const transform = computedStyle.transform;

    if (transform && transform !== 'none') {
      const values = transform.split('(')[1].split(')')[0].split(',');
      if (values.length >= 6) {
        const a = values[0];
        const b = values[1];
        const angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
        return `rotate(${angle}deg)`;
      }
    }

    const classList = element.classList;
    if (classList.contains('brand-story__image--1')) return 'rotate(-8deg)';
    if (classList.contains('brand-story__image--2')) return 'rotate(12deg)';
    if (classList.contains('brand-story__image--3')) return 'rotate(-15deg)';
    if (classList.contains('brand-story__image--4')) return 'rotate(8deg)';

    return '';
  }

  startAnimation() {
    if (this.isRunning) return;
    this.isRunning = true;
    this.animate();
  }

  stopAnimation() {
    this.isRunning = false;
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }

  animate() {
    if (!this.isRunning) return;

    this.images.forEach((img, index) => {
      img.time += img.speed;

      img.floatX = Math.sin(img.time) * 15;

      // Check if this is one of the top images (1 or 2)
      const isTopImage = img.element.classList.contains('brand-story__image--1') ||
        img.element.classList.contains('brand-story__image--2');

      if (isTopImage) {
        // For top images, float downwards with a larger buffer (20px to 40px)
        // This ensures they are always at least 20px below their CSS top position
        // to account for rotation and extreme edge cases
        img.floatY = 20 + (Math.cos(img.time * 0.7) + 1) * 10;
      } else {
        // Normal floating for other images (-20px to 20px)
        img.floatY = Math.cos(img.time * 0.7) * 20;
      }

      const transform = `translate(${img.floatX}px, ${img.floatY}px) ${img.baseRotation}`;
      img.element.style.transform = transform;
      img.element.style.setProperty('transform', transform, 'important');

    });

    this.animationId = requestAnimationFrame(() => this.animate());
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const brandStoryAnimation = new BrandStoryAnimation();
  window.brandStoryAnimation = brandStoryAnimation;
});

window.addEventListener('resize', () => {
  if (window.innerWidth <= 1200) {
    if (window.brandStoryAnimation) {
      window.brandStoryAnimation.stopAnimation();
    }
    document.querySelectorAll('.brand-story__image').forEach(img => {
      img.style.transform = '';
      img.style.removeProperty('transform');
    });
  }
});

if (window.innerWidth <= 1200) {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.brand-story__image').forEach(img => {
      img.style.transform = '';
      img.style.removeProperty('transform');
    });
  });
}
